// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"299":"bf6d84b6","579":"37ee57cb","605":"9e130480","654":"2e61453e","973":"c1099da6"}[chunkId] + ".chunk.js");